import AvailableHelper from "../Availability/AvailableHelper";
import {DateHelper} from "../../../Common/Date/DateHelper";
import HoursHelper from "../Availability/HoursHelper";
import DateService from "../../../Common/Date/DateService";
import {OrderType} from "../../../Api/types";
import {getParsedSessionOrderType} from "../../../../utils/order";
import CategoryHelper from "../Category/CategoryHelper";

class ItemHelper {
    static filterItemGroupItemsByMenuUsage(itemGroup: Record<string, any>, categories: Record<string, any>[]): Record<string, any> {
        const newItems: Record<string, any>[] = itemGroup.items.filter((item: Record<string, any>) => {
            return categories.some((category) => category.entities.some((entity: Record<string, any>) => entity.type === "ITEM" && entity.entity_id === item.item_id));
        });

        return {
            ...itemGroup,
            items: [...newItems].sort((a, b) => a.position - b.position)
        }
    }

    static getItemGroup(itemGroups: any, id: any) {
        return itemGroups.filter((x: any) => x.items.some((i: any) => i.item_id == id))[0];
    }

    static getItem(items: any, id: any) {
        return items.filter((item: any) => item.id === id)[0];
    }

    static getModifierGroup(modiferGroups: any, id: any) {
        let obj = modiferGroups.filter((modifierGroup: any) => modifierGroup.id === id);
        if (obj.length > 0) {
            return obj[0];
        }
        return undefined;
    }

    static getModifierGroupQuantityInfo(modifierGroup: any, parentItem: any) {
        let ovverides = parentItem.quantity_info_overrides;
        let id = modifierGroup.id;
        let quantityInfo = undefined as any;
        let modiferGroupOvverides = [];
        if (ovverides !== undefined) {
            modiferGroupOvverides = ovverides.filter((ovveride: any) => ovveride.context_type === 'MODIFIER_GROUP' && ovveride.context_id === id.toString());
        }
        if (modiferGroupOvverides.length > 0) {
            let modiferGroupOvveride = modiferGroupOvverides[0];
            quantityInfo = modiferGroupOvveride.quantity_info;
            return quantityInfo === undefined ? undefined : quantityInfo;
        } else {
            if (modifierGroup.quantity_info !== undefined) {
                quantityInfo = {}
                if (modifierGroup.quantity_info.max_permitted !== undefined) {
                    quantityInfo.max_permitted = modifierGroup.quantity_info.max_permitted;
                }
                if (modifierGroup.quantity_info.min_permitted !== undefined) {
                    quantityInfo.min_permitted = modifierGroup.quantity_info.min_permitted;
                }
                if (modifierGroup.quantity_info.charge_above !== undefined) {
                    quantityInfo.charge_above = modifierGroup.quantity_info.charge_above;
                }
                return quantityInfo;
            }
        }
        return undefined;
    }

    static getItemQuantityInfo(item: any, parentItem: any, modifierGroup: any) {
        let parentItemId = parentItem ? parentItem.id : undefined;
        let modifierGroupId = modifierGroup ? modifierGroup.id : undefined;

        let itemOvverides = undefined;
        if (parentItemId !== undefined && modifierGroupId !== undefined) {
            itemOvverides = parentItem.quantity_info_overrides.filter((parentItemQuantityInfoOvveride: any) => parentItemQuantityInfoOvveride.context_type === 'ITEM' && parentItemQuantityInfoOvveride.context_id === item.id.toString())[0];
            if (!itemOvverides) {
                itemOvverides = modifierGroup.quantity_info_overrides.filter((modifierGroupQuantityInfoOvveride: any) => modifierGroupQuantityInfoOvveride.context_type === 'ITEM' && modifierGroupQuantityInfoOvveride.context_id === item.id.toString())[0];
            }
            if (itemOvverides !== undefined && itemOvverides.quantity_info !== undefined) {
                return itemOvverides.quantity_info;
            }
        }
        return undefined;
    }

    static getPriceOvveride(item: any, parentItem: any, modifierGroup: any) {
        let parentItemId = parentItem !== undefined ? parentItem.id : undefined;
        let modifierGroupId = modifierGroup !== undefined ? modifierGroup.id : undefined;
        let itemPriceInfoOverride = undefined;
        let price = undefined;
        if (parentItemId !== undefined && modifierGroupId !== undefined) {
            itemPriceInfoOverride = item.price_info_overrides.filter((priceInfoOverride: any) => priceInfoOverride.context_type === 'ITEM' && priceInfoOverride.context_id === parentItemId.toString())[0];
            if (itemPriceInfoOverride === undefined) {
                itemPriceInfoOverride = item.price_info_overrides.filter((priceInfoOverride: any) => priceInfoOverride.context_type === 'MODIFIER_GROUP' && priceInfoOverride.context_id === modifierGroupId.toString())[0];
            }
            if (itemPriceInfoOverride !== undefined) {
                if (itemPriceInfoOverride.price !== undefined) {
                    price = itemPriceInfoOverride.price;
                }
            }
        }
        if (price === undefined) {
            price = item.price !== undefined ? item.price : undefined;
        }
        if (price !== undefined) {
            price = price.amount;
        }
        return price;
    }

    static isAvailabile(item: any, availabilities: any, date: any, orderType?: string | undefined, options?: {
        skipStatus?: boolean,
        skipAvailability?: boolean,
        skipType?: boolean;
    }) {
        if (options?.skipStatus !== true && item.status !== 'ENABLED') {
            return false;
        }
        if (options?.skipAvailability !== true && item.availability_id !== undefined) {
            let availability = AvailableHelper.getAvailability(availabilities, item.availability_id);
            if (availability.hours.length > 0 && !HoursHelper.isOpen(availability.hours, date)) {
                return false;
            }
        }
        if (options?.skipType !== true && orderType && item.order_types && item.order_types.length > 0 && !item.order_types.includes(orderType)) {
            return false;
        }
        if (item.suspension !== undefined && (item.suspension.suspend_until !== undefined || item.suspension.reason)) {
            const suspendUntilDate = item.suspension.suspend_until !== undefined ? DateHelper.fromString(item.suspension.suspend_until) : undefined;
            if (!suspendUntilDate || suspendUntilDate > date) {
                if (options?.skipType === true) {
                    return false;
                }

                const isAnyLimited = (item.suspension.order_types && item.suspension.order_types.length > 0) || (item.suspension.sources && item.suspension.sources.length > 0);
                if (!isAnyLimited) return false;
                const suspensionForOrderTypeExist = item.suspension.order_types && item.suspension.order_types.length > 0;
                const suspensionForSourcesExist = item.suspension.sources && item.suspension.sources.length > 0;
                const suspensionForOrderType = suspensionForOrderTypeExist && item.suspension.order_types.includes(orderType);
                const suspensionForSources = suspensionForSourcesExist && item.suspension.sources.includes("GOORDER");
                if (suspensionForOrderTypeExist && suspensionForSourcesExist) {
                    return !(suspensionForOrderType && suspensionForSources);
                }
                return !(suspensionForOrderType || suspensionForSources);
            }
        }
        return true;
    }

    static getTodayOpenHours(availability: any, date: any) {
        if (availability === undefined) {
            return undefined;
        }

        let dayOpenHours = HoursHelper.getOpenHours(availability.hours, date) as any;
        if (dayOpenHours.length == 0) {
            return undefined;
        }
        return dayOpenHours;
    }

    static getTodayOpenHoursString(availability: any, date: any) {
        let openHours = this.getTodayOpenHours(availability, date);
        if (openHours === undefined) {
            return undefined;
        }
        openHours = openHours.sort((a: any, b: any) => {
            return a.hour_from < b.hour_from ? -1 : 1;
        });
        let openHourStrings = openHours.map((x: any) => x.hour_from + " - " + x.hour_to);
        return openHourStrings.join(", ");
    }

    static getNearestAvailabilityDateForItem(item: any, availabilities: any[], pickDate: string | undefined, orderType?: OrderType, maxSearchDate?: Date) {
        const itemAvailability = AvailableHelper.getAvailability(availabilities, item.availability_id);
        const isSuspended = !ItemHelper.isAvailabile(item, availabilities, DateService.emptyOrNow(pickDate), orderType, {
            skipAvailability: true,
            skipStatus: true,
        });

        if (isSuspended) {
            let suspensionEndDate = new Date(item.suspension?.suspend_until);

            if (maxSearchDate && suspensionEndDate && maxSearchDate.getTime() < suspensionEndDate.getTime()) {
                return {
                    alwaysAvailable: false,
                    dateFrom: undefined,
                    dateTo: undefined
                }
            }

            if (item.suspension?.order_types?.length) {
                if (item.suspension?.order_types.includes(orderType)) {
                    return {
                        alwaysAvailable: false,
                        dateFrom: suspensionEndDate,
                        dateTo: undefined
                    }
                } else {
                    return {
                        alwaysAvailable: true,
                        dateFrom: undefined,
                        dateTo: undefined
                    }
                }
            } else {
                return {
                    alwaysAvailable: false,
                    dateFrom: suspensionEndDate,
                    dateTo: undefined
                }
            }
        } else if (itemAvailability) {
            const dates = AvailableHelper.getNearestOpenDateFromNowOrDate([itemAvailability], DateService.emptyOrNow(pickDate), true, maxSearchDate);
            return {
                alwaysAvailable: false,
                dateFrom: dates?.dateFrom,
                dateTo: dates?.dateTo
            }
        }

        return {
            alwaysAvailable: true,
            dateFrom: undefined,
            dateTo: undefined
        }
    }

    static isItemAvailableForOrderType(item: any, orderType: OrderType, menus: any[], categories: any[]) {
        const itemCategories = ItemHelper.getCategoriesForItem(item, categories);
        const anyMenuWithOrderType = itemCategories.some((category: any) => {
            const menusWithCategory = CategoryHelper.getMenusForCategory(menus, category);
            return menusWithCategory.some((menu: any) => menu[getParsedSessionOrderType(orderType).toLowerCase()] === true);
        });

        if (!anyMenuWithOrderType) return false;

        return !item.disabled && !item.selected_order_type_disabled;
    }

    static getCategoriesForItem(item: any, categories: any[]) {
        return categories.filter((category: any) => category.entities.some((entity: any) => entity.entity_id === item.id));
    }

    static getItemPromotion = (item: any, promotions: any[]) => {
        const valuePromotions = promotions.filter((x: any) => x.value_money && x.value_money.amount);

        return valuePromotions.filter((x: any) => x.items.some((y: any) => y.order_item_id == item.id))[0];
    }

    static getItemFromCategoryItems(item: Record<string, any>, itemGroup: Record<string, any> | undefined, categoryItems: Record<string, any>[]) {
        return categoryItems.find((entity: Record<string, any>) => {
            if (itemGroup) {
                return entity.items?.some((subItem: Record<string, any>) => subItem.item_id === item.id);
            }

            return entity.id === item.id;
        })
    }
}

export default ItemHelper;